// extracted by mini-css-extract-plugin
module.exports = {"title":"_12b9e","row":"de379","content":"_04bf1"};